import(/* webpackMode: "eager" */ "/vercel/path0/components/pages/authors/AuthorPage.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-no-ssr.js")